import { useTranslation } from "react-i18next";
import "./OpenGymLabel.scss";

export const OpenGymLabel = () => {
  const { t } = useTranslation();

  return (
    <div className="open-gym">
      <p className="open-gym__text">{t("OpenGym")}</p>
    </div>
  );
};
